// extracted by mini-css-extract-plugin
module.exports = {"container":"TextInput_container__1rQOt","text_input":"TextInput_text_input__dbEfQ","disabled":"TextInput_disabled__1qCRm","prefix":"TextInput_prefix__29SF2"};